import React, { useEffect, useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import styled from 'styled-components';
import Header from './components/Header';
import MsgInfo from './components/MsgInfo';
import Footer from './components/Footer';
import SessionTimeout from './components/SessionTimeout';
import SessionWarningBar from './components/SessionTimeout/SessionWarningBar';
import Routes from './Routes';
import { ErrorBoundary } from './components/hoc';
import 'semantic-ui-css/semantic.min.css';
import './static/assets/css/dashboard.css';
import './static/assets/css/tab.css';
import './static/workspace/css/main.css';
import './static/workspace/css/style.css';
import './static/workspace/css/maine.css';
import './App.css';
import './common.css';
import { DarkModeProvider } from './context/DarkModeContext';
import { useApiError } from './hooks/useApiError';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export const mobileBreakpoint = '800px';

const Wrapper = styled.div`
  div.container {
    padding: 0;
    max-width: 1200px;
    width: 95%;
  }
`;

const Main = styled.div.attrs(({ className = '' }) => ({
  className: ['main', className].filter(Boolean).join(' '),
}))`
  &.public-theme {
    font-family: 'DM Sans', Helvetica, Arial, sans-serif;
  }
`;

// Keeps the header and footer usable when a page crashes, and clears the error
// as soon as the user navigates to another page.
const RouteErrorBoundary = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary variant="page" resetKey={pathname}>
      {children}
    </ErrorBoundary>
  );
};

const App = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isResolvingUser, setIsResolvingUser] = useState(true);
  const { error, handleApiError, clearError } = useApiError();

  useEffect(() => {
    setIsResolvingUser(true);
    try {
      const storedUser = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      if (storedUser && token) {
        setIsAuthenticated(true);
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsResolvingUser(false);
    }
  }, [handleApiError]);


  return (
    <DarkModeProvider>
      <DndProvider backend={HTML5Backend}>
        <Wrapper>
          <Provider store={props.store}>
            <ErrorBoundary>
              <GlobalStyles />
              <BrowserRouter>
                <Main
                  className={
                    isAuthenticated ? 'authenticated app-theme' : 'public-theme'
                  }
                >
                  <SessionTimeout />
                  <Header />
                  <MsgInfo />
                  <SessionWarningBar />
                  {/* <FloatingDocumentUplaodLoader /> */}
                  {error && (
                    <MsgInfo
                      message={error.message}
                      type="error"
                      onClose={clearError}
                    />
                  )}
                  <RouteErrorBoundary>
                    <Routes
                      user={user}
                      isAuthenticated={isAuthenticated}
                      isResolvingUser={isResolvingUser}
                    />
                  </RouteErrorBoundary>
                </Main>
                <Footer />
              </BrowserRouter>
            </ErrorBoundary>
          </Provider>
        </Wrapper>
      </DndProvider>
    </DarkModeProvider>
  );
};

export default App;
